import type { GuidedDockView } from "../routing/guided-views.js";

export const GUIDED_DOCK_LABELS: Record<GuidedDockView, string> = {
  home: "Command Center",
  projects: "Projects",
  more: "More",
};
